import React, { Fragment, useState } from 'react';
import ResourceLink from './resourceLink';
import { InputText } from 'view/common/elements/input';
import TextBox from 'view/common/elements/textbox';
import Button from 'view/common/elements/button';
import httpClient from 'httpClient';
import Notification from 'view/common/notification';
import Link from 'view/common/elements/link';
import OutlineButton from 'view/common/elements/outlineButton';

const AllResourceLinks = (props) => {
  const {links, onLinkSaved} = {...props}
  const [showNewLink, setShowNewLink] = useState(false);

  const [linkUrl, setLinkUrl] = useState("");
  const [linkUrlError, setLinkUrlError] = useState("");
  const [linkDescription, setLinkDescription] = useState("");
  const [linkDescriptionError, setLinkDescriptionError] = useState("");
  const [linkSaving, setLinkSaving] = useState(false);

  const [showAddLink, setShowAddLink] = useState(true);

  const [editedLinkId, setEditedLinkId] = useState(null);

  const saveLink = async () => {
    console.log("Saving Link", linkUrl, linkDescription);
    setLinkSaving(true);
    try {
      const payload = {
        url: linkUrl,
        description: linkDescription,
        id:editedLinkId,
        unit: props.unit,
        biomarker: props.biomarker,
        type:props.type,
      }
      const response = await httpClient.post("/administration/v1/saveHazardResourceLink", payload);
      console.log(response);
      if(!response.error) {
        Notification.success(`Link Saved successfully`);
        
        setLinkUrl("");
        setLinkDescription("");
        closeNewLink();
        onLinkSaved({
          url: linkUrl,
          description: linkDescription,
          id: response.id
        })
      } else {
        // Notification.error("An error was encountered1")
      }
      
    } catch (ex) {
      Notification.error("An error was encountered");
      console.log(ex)
    } finally {
      setLinkSaving(false)
    }
  }

  const showNewLinkForm = (e=null) => {
    if(e) {
      e.preventDefault();
    }
    
    setShowNewLink(true);
    setShowAddLink(false);
  }

  const closeNewLink = () => {
    setShowNewLink(false);
    setShowAddLink(true);
    setEditedLinkId(null);
    setLinkUrl("")
    setLinkDescription("")
    setLinkUrlError('');
    setLinkDescriptionError('')
  }

  const onLinkEdit = (link) => {
    setLinkUrl(link.url);
    setLinkDescription(link.description);
    setEditedLinkId(link.id);
    showNewLinkForm();
  }

  const onDescriptionChanged = (val) => {
    if(val.length > 250) {
      setLinkDescriptionError("This description exceeds the maximum length of 250 characters");
    } else {
      setLinkDescriptionError("");
    }

    setLinkDescription(val);
  }
  return ( 
    <Fragment>
      {
        links.map((link, idx)=>{
          if(link) {

          
            return (
              <ResourceLink
                index={++idx}
                link={link}
                key={"Link "+idx}
                onLinkEdit={onLinkEdit}
                onLinkDeleted={props.onLinkDeleted}
              />
            )
          }
          return false
        })
      }
      {
        showAddLink &&
        <Link
          href="#"
          onClick={showNewLinkForm}
          text={"+ Add a Link"}
          className={`mt-3 mb-10 inline-block`}
        />
      }
      {showNewLink &&
        <div className={`mt-3 mb-10 inline-block border border-uhblue px-2 pt-2 pb-5 rounded mx-auto w-full` }>
          <div className={`w-full font-bold text-center `}>{editedLinkId?"Edit":"New"} Link</div>
          <InputText
            id="link"
            value={linkUrl}
            onChange={setLinkUrl}
            error={linkUrlError}
            placeholder={"Paste link here"}
            className={`mb-2`}
            onFocus={() => setLinkUrlError('')}
          />
          <TextBox
            content={linkDescription}
            name={"hazards"}
            onChange={onDescriptionChanged}
            error={linkDescriptionError}
            
            placeholder="Optional description of the link"
            width="56"
            height="2"
          />
          <Button
            text="Save Link"
            onClick={saveLink}
            loading={linkSaving}
            disabled={linkUrl === "" || linkDescriptionError!== '' || linkUrlError !==''}
          />
          <OutlineButton
            text={`Close`}
            onClick={closeNewLink}
            className={`ml-2 mt-2`}
          />
        </div>
      }
    </Fragment>
  ) 
}

export default AllResourceLinks;